const memory = new Map<string, string>();

let isPersisted = false;

const hasBrowserStorage = () => typeof window !== 'undefined';

const admittedSessionStorage = {
  getItem: (key: string): string | null => {
    if (memory.has(key)) {
      return memory.get(key) ?? null;
    }

    if (!hasBrowserStorage()) {
      return null;
    }

    const stored = window.localStorage.getItem(key);

    if (stored) {
      isPersisted = true;
      memory.set(key, stored);
    }

    return stored;
  },
  setItem: (key: string, value: string): void => {
    memory.set(key, value);

    if (isPersisted && hasBrowserStorage()) {
      window.localStorage.setItem(key, value);
    }
  },
  removeItem: (key: string): void => {
    memory.delete(key);
    isPersisted = false;

    if (hasBrowserStorage()) {
      window.localStorage.removeItem(key);
    }
  },
};

const persistAdmittedSession = (): void => {
  isPersisted = true;

  if (!hasBrowserStorage()) {
    return;
  }

  memory.forEach((value, key) => {
    window.localStorage.setItem(key, value);
  });
};

export {
  admittedSessionStorage,
  persistAdmittedSession,
};
